const {
  settings: {
    endpoints: { whitelabelDir, imgDir },
  },
} = ADV;

export default (path, isFromRemote = false) => `${isFromRemote ? whitelabelDir : imgDir}${path}`;
